import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: '#F7F7FB',
      minHeight: '100vh',
      padding: '40px',
      [theme.breakpoints.down('sm')]: {
        padding: '20px',
      },
    },
    container: {
      padding: '34px',
      margin: '0 auto',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '30px',
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: '15px',
      },
    },
    title: {
      fontFamily: 'Poppins',
      fontWeight: 600,
      fontSize: '24px',
      color: '#000A8C'
    },
    datePickerContainer: {
      position: 'relative',
    },
    datePickerButton: {
      backgroundColor: '#FFFFFF',
      border: '1px solid #CDCEDA',
      borderRadius: '8px',
      padding: '10px 20px',
      textTransform: 'none',
      fontFamily: 'Poppins',
      fontWeight: 500,
      fontSize: '14x',
      color: '#151528',
      minWidth: '220px',
      justifyContent: 'space-between',
      '&:hover': {
        backgroundColor: '#F7F7FB',
        border: '1px solid #CDCEDA',
      },
      '& .MuiButton-startIcon': {
        marginRight: '8px',
        color: '#151528',
      },
      '& .MuiButton-endIcon': {
        marginLeft: '8px',
        color: '#151528',
      },
    },
    dateRangePickerWrapper: {
      padding: '20px',
      '& .rdrDefinedRangesWrapper': {
        display: 'none',
      },
      '& .rdrDateDisplayWrapper': {
        display: 'none',
      },
    },
    clearButton: {
      fontFamily: 'Poppins',
      textTransform: 'none',
      fontSize: '13px',
      color: '#6B7280',
      marginTop: '12px',
      '&:hover': {
        backgroundColor: '#F7F7FB',
      },
    },
    statsContainer: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3, 1fr)',
      gap: '20px',
      marginBottom: '40px',
      [theme.breakpoints.down('md')]: {
        gridTemplateColumns: 'repeat(2, 1fr)',
      },
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
      },
    },
    statCard: {
      backgroundColor: '#FFFFFF',
      borderRadius: '16px',
      padding: '30px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      '&:hover': {
        transform: 'translateY(-4px)',
        boxShadow: '0px 4px 16px rgba(0, 0, 0, 0.1)',
      },
    },
    statNumber: {
      fontFamily: 'Poppins',
      fontWeight: 700,
      fontSize: '32px',
      color: '#000A8C',
      marginBottom: '10px'
    },
    statLabel: {
      fontFamily: 'Poppins',
      fontWeight: 500,
      fontSize: '18px',
      color: '#000A8C',
      textAlign: 'center',
      lineHeight: '1.4',
    },
    sectionTitle: {
      fontFamily: 'Poppins',
      fontWeight: 600,
      fontSize: '20px',
      color: '#000A8C',
      marginBottom: '25px',
    },
    starsContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    userName: {
      fontFamily: 'Poppins',
      fontWeight: 500,
      fontSize: '14px',
      color: '#23296F',
      marginBottom: '4px',
    },
    userEmail: {
      fontFamily: 'Poppins',
      fontWeight: 400,
      fontSize: '12px',
      color: '#6B7280',
    },
    commentaireContainer: {
      display: 'flex',
      alignItems: 'flex-start',
      justifyContent: 'space-between',
      width: '100%',
      gap: '10px',
    },
    commentaireText: {
      fontFamily: 'Poppins',
      fontWeight: 400,
      fontSize: '14px',
      color: '#23296F',
      flex: 1,
      lineHeight: '1.5',
      wordWrap: 'break-word',
      overflowWrap: 'break-word',
      whiteSpace: 'normal',
    },
    expandButton: {
      color: '#23296F',
      padding: '4px',
      flexShrink: 0,
      '&:hover': {
        backgroundColor: 'rgba(35, 41, 111, 0.08)',
      },
    },
  }),
);

